import { type MotionProps, m } from 'motion/react';
import { varContainer } from './variants/container';

interface Props extends MotionProps {
  className?: string;
}

/**
 * MotionContainer
 * ```tsx
 * <MotionContainer>
 *   <motion.div variants={varFade().in}>
 *     <h1>Animated Content</h1>
 *   </motion.div>
 * </MotionContainer>
 * ```
 *
 */
export default function MotionContainer({ children, className }: Props) {
  return (
    <m.div
      initial="initial"
      animate="animate"
      exit="exit"
      variants={varContainer()}
      className={className}
    >
      {children}
    </m.div>
  );
}
